module.exports = __webpack_public_path__ + "static/img/bg34.a9b2628b.png";